import React from 'react';

const IconIn = props =>
  <svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
    <path d="M9.543 14.759l5.6-3.759l-5.6-3.759v2.654H4.497v2.21h5.046V14.759z" />
    <path d="M15.176 4.004H8.729c-1.284 0-2.328 1.004-2.328 2.239v2.439h1.563V6.243c0-0.406 0.343-0.736 0.766-0.736 h6.446c0.422 0 0.765 0.33 0.765 0.736v5.154v4.36c0 0.407-0.343 0.736-0.765 0.736H8.729c-0.423 0-0.766-0.329-0.766-0.736V13.35 H6.401v2.407c0 1.235 1.044 2.239 2.328 2.239h6.446c1.283 0 2.327-1.004 2.327-2.239V6.243C17.503 5.008 16.459 4.004 15.176 4.004 z" />
  </svg>;

export default IconIn;
